import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// import {
//   getStaffs,
//   getStrucList,
//   getBTypeList
// } from '@/api/task/'
import { getStaffs, getStrucList, getBTypeList } from '@api/public';
import setMenu from '@/permission';
import util from '@/libs/util.js';
import store from './../../index';
import AwaitToJs from '@/libs/awaitToJs';
import { getList as getDictionaryList } from '@/api/setting/dictionary';
var userInfo = util.cookies.get('userInfo');
var menus = localStorage.getItem('cpscc-menus');
var tenantId = localStorage.getItem('cpscc-tenantId');
if (menus && menus !== 'undefined') {
  var m = JSON.parse(menus);
  if (Array.isArray(m)) {
    menus = m;
  } else {
    menus = [];
  }
} else {
  menus = [];
}
var mapKey = '02f92f65958a9e6239ca601e321ba4d0';
function loadScript() {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = "https://api.tianditu.gov.cn/api?v=4.0&tk=".concat(mapKey);
  document.head.appendChild(script);
}
var Module = {
  namespaced: true,
  state: {
    bTypeList: [],
    staffsList: [],
    strucList: [],
    userInfo: userInfo ? JSON.parse(userInfo) : {},
    menus: menus,
    localStorageName: 'cpscc-correspondence-batch-model',
    sendCompany: [],
    mapKey: mapKey,
    backConfirmExplainList: [{
      label: '自定义',
      value: '0'
    }, {
      label: '银行以自有格式回函，缺：附表：资金归集（资金池或其他资金管理）账户具体信息',
      value: '1'
    }, {
      label: '纸质询证函数据与系统模板生成函证预览不一致',
      value: '2'
    }, {
      label: '项目组未通过插件合并及推送其他类型询证函附表文件',
      value: '3'
    }, {
      label: '回函双边签章',
      value: '4'
    }, {
      label: '回函签章与系统函证对象名称不一致',
      value: '5'
    }, {
      label: '回函签署日期异常（早于发函快递或晚于回函快递寄出日期）',
      value: '6'
    }, {
      label: '回函用章不规范（未使用函证对象公章、财务专用章或对口业务部门章）',
      value: '7'
    }, {
      label: '未取得被审计单位签章授权',
      value: '8'
    }, {
      label: '复印件或彩色打印件回函',
      value: '9'
    }],
    expressDataLoading: false,
    expressDataPromise: null,
    routeIsReady: false,
    levelType: {
      partners: 3,
      managers: 2,
      leaders: 1,
      participants: -1,
      quality4: 4,
      quality5: 5,
      inquisitor: -1
    },
    isHX: location.hostname === 'i.fjhxcpa.com' || process.env.VUE_APP_BUILD_TYPE === 'dev' || process.env.VUE_APP_BUILD_TYPE === 'test',
    levelNum: {
      3: 'partners',
      2: 'managers',
      1: 'leaders',
      '-1': 'participants',
      4: 'quality4',
      5: 'quality5'
      // '-1': "inquisitor"
    },
    levelName: {
      partners: '合伙人',
      managers: '经理',
      leaders: '现场负责人',
      participants: '参与人员',
      quality4: '四级质控人员',
      quality5: '五级质控人员',
      inquisitor: '项目查询人员',
      admin: '函证中心管理员',
      sender: '发函操作员',
      replyPerson: '回函操作员'
    },
    levelKey: {
      合伙人: 'partners',
      经理: 'managers',
      现场负责人: 'leaders',
      参与人员: 'participants',
      四级质控人员: 'quality4',
      五级质控人员: 'quality5',
      项目查询人员: 'inquisitor',
      函证中心管理员: 'admin',
      发函操作员: 'sender',
      回函操作员: 'replyPerson'
    },
    tableHeight: window.innerHeight * 0.693,
    needToUpdatePageList: [],
    tenantId: tenantId,
    printQueue: [],
    correspondenceType: ['银行询证函', '验资业务银行询证函', '企业往来询证函', '代管存货询证函', '工程合同询证函', '其他类型询证函', '其他类型询证函_自定表头'],
    reTypes: ['项目组邮件', '函证中心邮件', '人员跟函', '电子邮件回函', '电子函证回函', '传真回函', '其他']
  },
  getters: {
    getBTypeList: function getBTypeList(state) {
      return state.bTypeList;
    },
    isHasPermission: function isHasPermission(state) {
      return function () {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var myRoles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var userInfo = state.userInfo;
        var roleTypes = {
          0: ['合伙人', '经理', '现场负责人'],
          1: ['合伙人', '经理'],
          2: ['合伙人', '经理', '现场负责人', '质控'],
          3: ['合伙人', '经理', '现场负责人', '参与人员']
        };
        var baseRoles = [];
        if (userInfo.data2) {
          var data = userInfo.data2;
          if (Array.isArray(data.roles)) {
            baseRoles = data.roles;
          }
        }
        var roles = roleTypes[type];
        var _myRoles = Array.isArray(myRoles) && myRoles.length ? myRoles : baseRoles;
        var res = roles.some(function (item) {
          return _myRoles.indexOf(item) !== -1;
        });
        return res;
      };
    }
  },
  mutations: {
    updateNeedToUpDatePageList: function updateNeedToUpDatePageList(state, data) {
      if (data.isAdd) {
        state.needToUpdatePageList.push(data.url);
      } else {
        state.needToUpdatePageList = state.needToUpdatePageList.filter(function (item) {
          return item !== data.url;
        });
      }
    },
    logout: function logout(state) {
      state.userInfo = undefined;
      store.dispatch('d2admin/account/logout');
      // store.state.d2admin.logout();
    },
    updatePrintQueue: function updatePrintQueue(state, data) {
      state.printQueue = data;
    },
    updateUserInfo: function updateUserInfo(state, data) {
      state.userInfo = data;
    },
    updateRouteState: function updateRouteState(state, data) {
      state.routeIsReady = data;
    },
    setBTypeList: function setBTypeList(state, data) {
      state.bTypeList = data;
    },
    setStaffsList: function setStaffsList(state, data) {
      state.staffsList = data;
    },
    setStrucList: function setStrucList(state, data) {
      state.strucList = data;
    },
    updateMenus: function updateMenus(state, data) {
      state.menus = data;
      localStorage.setItem('cpscc-menus', JSON.stringify(data));
    }
  },
  actions: {
    init: function init(_ref) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var commit, _yield$Promise$all, _yield$Promise$all2, staffsData, strucListData, typeData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              commit = _ref.commit;
              _context.n = 1;
              return Promise.all([getStaffs(), getStrucList(), getBTypeList()]);
            case 1:
              _yield$Promise$all = _context.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              staffsData = _yield$Promise$all2[0];
              strucListData = _yield$Promise$all2[1];
              typeData = _yield$Promise$all2[2];
              commit('setStaffsList', staffsData.data);
              commit('setStrucList', strucListData.data);
              commit('setBTypeList', typeData.data);
              _context.n = 2;
              return setMenu();
            case 2:
              loadScript();
              return _context.a(2, Promise.resolve());
          }
        }, _callee);
      }))();
    },
    getExpressInfo: function getExpressInfo(_ref2) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var state;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              state = _ref2.state;
              if (!state.expressDataLoading) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, state.expressDataPromise);
            case 1:
              if (!state.sendCompany.length) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, Promise.resolve(state.sendCompany));
            case 2:
              state.expressDataLoading = true;
              state.expressDataPromise = new Promise(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resolve, reject) {
                  var _yield$AwaitToJs, _yield$AwaitToJs2, err, data, list;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _context2.n = 1;
                        return AwaitToJs(getDictionaryList({
                          page: 1,
                          length: 99999,
                          type: 'c02SendCompany'
                        }));
                      case 1:
                        _yield$AwaitToJs = _context2.v;
                        _yield$AwaitToJs2 = _slicedToArray(_yield$AwaitToJs, 2);
                        err = _yield$AwaitToJs2[0];
                        data = _yield$AwaitToJs2[1];
                        state.expressDataLoading = false;
                        if (!err) {
                          _context2.n = 2;
                          break;
                        }
                        return _context2.a(2, reject(err));
                      case 2:
                        if (!(data && data.data && Array.isArray(data.data.datas))) {
                          _context2.n = 3;
                          break;
                        }
                        list = data.data.datas.sort(function (a, b) {
                          return a.n04Sort - b.n04Sort;
                        });
                        list = list.map(function (item) {
                          return {
                            text: item.n04Value,
                            code: item.n04ExtValue
                          };
                        });
                        list.splice(0, 0, {
                          text: 'N/A',
                          code: 'N/A'
                        });
                        state.sendCompany = list;
                        return _context2.a(2, resolve(list));
                      case 3:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function (_x, _x2) {
                  return _ref3.apply(this, arguments);
                };
              }());
              return _context3.a(2, state.expressDataPromise);
          }
        }, _callee3);
      }))();
    }
  }
};
export default Module;